import { Component, OnInit } from '@angular/core';

import { FormControl, FormGroup } from '@angular/forms';
import { forkJoin, Subscription } from 'rxjs';
import { LifestyleService } from 'src/app/services/ha-new/lifestyle.service';
import { SpinnerComponent } from 'src/app/modules/shared/spinner/spinner.component';
import { ActivatedRoute } from '@angular/router';
import { LookupService } from 'src/app/services/ha-new/lookup.service';
import { NewHAService } from 'src/app/services/ha-new/new-ha.service';

@Component({
	selector: 'app-substance-abuse',
	templateUrl: './substance-abuse.component.html',
	styleUrls: ['./substance-abuse.component.scss'],
})
export class SubstanceAbuseComponent implements OnInit {
	/** Data carrier subscriptions */
	subscriptions: Subscription[] = [];
	/** holds ha id */
	healthAssessmentID: number = 0;
	/** holds appointment id */
	apptID: any;
	/** holds readOnly flag */
	readOnly: boolean = false;
	substanceAbuseData: any = {};
	substanceAbuseForm: FormGroup;
	currentlySmokeCigarettes: boolean;
	everSmokeCigarettes: boolean;
	smokedEcigarettesPastYear: boolean;
	usedMarijuanaPastYear: boolean;
	recreationalDrugsPastYear: boolean;

	alcoholDrinksPerDayLookupValues: any = [];

	alcoholDrinksMoreThanSixLookupValues: any = [];
	alcoholDrinksFrequencyLookupValues: any = [];
	concernLookupValues: any = [];

	drinkingFrequencyPastYearSlider = {
		step: 1,
		tickInterval: 1,
		min: 0,
		max: 0,
	};
	drinksPerDayPastYearSlider = {
		step: 1,
		tickInterval: 1,
		min: 0,
		max: 0,
	};
	drinksMoreThanSixPastYearSlider = {
		step: 1,
		tickInterval: 1,
		min: 0,
		max: 0,
	};

	concernSlider = {
		step: 1,
		tickInterval: 1,
		min: 0,
		max: 0,
	};

	scrollTo = '';
	returningUser: boolean = false;

	constructor(
		private lifestyleService: LifestyleService,
		private spinner: SpinnerComponent,
		private activatedRoute: ActivatedRoute,
		private lookupService: LookupService,
		private haService: NewHAService
	) {
		this.activatedRoute.queryParams.subscribe(params => {
			//console.log('params:', params);
			this.apptID = params.apptID;
			this.readOnly = params.readOnly === 'true';
			this.healthAssessmentID = params.healthAssessmentID;
			this.returningUser = params.returningUser === 'true';
			if (this.scrollTo != 'false') {
				this.scrollTo = params.section;
			}
		});
	}

	ngOnInit() {
		this.initializeSubstanceAbuseForm();
		this.getLookup();
	}

	getAlcoholFreqValue(index) {
		if (this.alcoholDrinksFrequencyLookupValues[index - 1])
			return this.alcoholDrinksFrequencyLookupValues[index - 1].name;
		else if (this.alcoholDrinksFrequencyLookupValues[0]) return this.alcoholDrinksFrequencyLookupValues[0].name;
	}

	getDrinksPerDayPastYearValue(index) {
		if (this.alcoholDrinksPerDayLookupValues[index - 1]) return this.alcoholDrinksPerDayLookupValues[index - 1].name;
		else if (this.alcoholDrinksPerDayLookupValues[0]) return this.alcoholDrinksPerDayLookupValues[0].name;
	}
	getDrinksMoreThanSixValue(index) {
		if (this.alcoholDrinksMoreThanSixLookupValues[index - 1])
			return this.alcoholDrinksMoreThanSixLookupValues[index - 1].name;
		else if (this.alcoholDrinksMoreThanSixLookupValues[0]) return this.alcoholDrinksMoreThanSixLookupValues[0].name;
	}
	getConcernValue(index) {
		if (this.concernLookupValues[index - 1]) return this.concernLookupValues[index - 1].name;
		else return this.concernLookupValues[0].name;
	}

	getLookup() {
		this.spinner.startLoader();
		forkJoin({
			alcoholDrinksFrequencyLookup: this.lookupService.alcoholDrinksFrequencyookup(),
			alcoholDrinksPerDayLookup: this.lookupService.alcoholDrinksPerDayLookup(),
			alcoholDrinksMoreThanSixLookup: this.lookupService.alcoholDrinksMoreThanSixLookup(),
			concernLookup: this.lookupService.getCharacterizationDescribeRatingOptionsLookup(),
			substanceAbuse: this.lifestyleService.getSubstanceAbuse(this.apptID, this.healthAssessmentID),
		}).subscribe(
			res => {
				this.alcoholDrinksFrequencyLookupValues = res.alcoholDrinksFrequencyLookup.data;
				this.alcoholDrinksPerDayLookupValues = res.alcoholDrinksPerDayLookup.data;
				this.alcoholDrinksMoreThanSixLookupValues = res.alcoholDrinksMoreThanSixLookup.data;
				this.concernLookupValues = res.concernLookup.data;
				this.getSubstanceaAbuse(res.substanceAbuse);
				this.spinner.stopLoader();

				if (this.scrollTo != 'false') {
					if (this.haService.scrollView(this.scrollTo)) {
						this.scrollTo = 'false';
					}
				}
			},
			err => {
				this.spinner.stopLoader();
				console.error(`[${SubstanceAbuseComponent.name}][${this.getLookup.name}]`, err);
			}
		);
	}

	radioButtonChanged(event) {
		if (event.source.name == 'currentlySmokeCigarettes') {
			this.currentlySmokeCigarettes = event.value;
		} else if (event.source.name == 'everSmokeCigarettes') {
			this.everSmokeCigarettes = event.value;
		} else if (event.source.name == 'smokedEcigarettesPastYear') {
			this.smokedEcigarettesPastYear = event.value;
		} else if (event.source.name == 'usedMarijuanaPastYear') {
			this.usedMarijuanaPastYear = event.value;
		} else if (event.source.name == 'recreationalDrugsPastYear') {
			this.recreationalDrugsPastYear = event.value;
		}
	}
	getSubstanceaAbuse(response) {
		this.substanceAbuseData = response.data;
		//console.log(this.substanceAbuseData)

		this.substanceAbuseForm.controls.currentlySmokeCigarettes.setValue(
			this.substanceAbuseData.currentlySmokeCigarettes
		);
		this.currentlySmokeCigarettes = this.substanceAbuseData.currentlySmokeCigarettes;

		this.substanceAbuseForm.controls.everSmokeCigarettes.setValue(this.substanceAbuseData.everSmokeCigarettes);
		this.everSmokeCigarettes = this.substanceAbuseData.everSmokeCigarettes;

		this.substanceAbuseForm.controls.smokedEcigarettesPastYear.setValue(
			this.substanceAbuseData.smokedEcigarettesPastYear
		);
		this.smokedEcigarettesPastYear = this.substanceAbuseData.smokedEcigarettesPastYear;

		this.substanceAbuseForm.controls.usedMarijuanaPastYear.setValue(this.substanceAbuseData.usedMarijuanaPastYear);
		this.usedMarijuanaPastYear = this.substanceAbuseData.usedMarijuanaPastYear;

		this.substanceAbuseForm.controls.recreationalDrugsPastYear.setValue(
			this.substanceAbuseData.recreationalDrugsPastYear
		);
		this.recreationalDrugsPastYear = this.substanceAbuseData.recreationalDrugsPastYear;

		this.substanceAbuseForm.controls.cigarettesPerDay.setValue(this.substanceAbuseData.cigarettesPerDay);
		this.substanceAbuseForm.controls.yearsOfSmoking.setValue(this.substanceAbuseData.yearsOfSmoking);
		this.substanceAbuseForm.controls.yearQuitSmoking.setValue(this.substanceAbuseData.yearQuitSmoking);

		this.substanceAbuseForm.controls.yearsSmokedPreviously.setValue(this.substanceAbuseData.yearsSmokedPreviously);

		this.substanceAbuseForm.controls.cigarettesPerDayPreviously.setValue(
			this.substanceAbuseData.cigarettesPerDayPreviously
		);

		this.drinkingFrequencyPastYearSlider['max'] = this.alcoholDrinksFrequencyLookupValues.length;
		this.drinkingFrequencyPastYearSlider['min'] = 1;

		if (this.substanceAbuseData.drinkingFrequencyPastYear) {
			this.substanceAbuseForm.controls.drinkingFrequencyPastYear.setValue(
				this.substanceAbuseData.drinkingFrequencyPastYear
			);
		}

		this.drinksPerDayPastYearSlider['max'] = this.alcoholDrinksPerDayLookupValues.length;
		this.drinksPerDayPastYearSlider['min'] = 1;

		if (this.substanceAbuseData.drinksPerDayPastYear) {
			this.substanceAbuseForm.controls.drinksPerDayPastYear.setValue(this.substanceAbuseData.drinksPerDayPastYear);
		}

		this.drinksMoreThanSixPastYearSlider['max'] = this.alcoholDrinksMoreThanSixLookupValues.length;
		this.drinksMoreThanSixPastYearSlider['min'] = 1;

		if (this.substanceAbuseData.drinksMoreThanSixPastYear) {
			this.substanceAbuseForm.controls.drinksMoreThanSixPastYear.setValue(
				this.substanceAbuseData.drinksMoreThanSixPastYear
			);
		}

		this.concernSlider['max'] = this.concernLookupValues.length;
		this.concernSlider['min'] = 1;

		if (this.substanceAbuseData.concernedAboutMarijuanaUse) {
			this.substanceAbuseForm.controls.concernedAboutMarijuanaUse.setValue(
				this.substanceAbuseData.concernedAboutMarijuanaUse
			);
		}
		if (this.substanceAbuseData.concernedAboutDrugUse) {
			this.substanceAbuseForm.controls.concernedAboutDrugUse.setValue(this.substanceAbuseData.concernedAboutDrugUse);
		}

		if (this.substanceAbuseData.concernedAboutEcigaretteUse) {
			this.substanceAbuseForm.controls.concernedAboutEcigaretteUse.setValue(
				this.substanceAbuseData.concernedAboutEcigaretteUse
			);
		}
	}

	next() {
		if (!this.readOnly) {
			if (this.substanceAbuseForm.valid) {
				this.saveSubstanceAbuse();
			}
			this.haService.redirect(
				[],
				[],
				['safety'],
				this.apptID,
				this.healthAssessmentID,
				this.readOnly,
				'lifestyle-safety',
				this.returningUser
			);
		}
	}

	saveSubstanceAbuse() {
		if (!this.currentlySmokeCigarettes) {
			this.substanceAbuseForm.controls.cigarettesPerDay.setValue(undefined);
			this.substanceAbuseForm.controls.yearsOfSmoking.setValue(undefined);
		} else {
			this.everSmokeCigarettes = false;
		}
		if (!this.everSmokeCigarettes) {
			this.substanceAbuseForm.controls.cigarettesPerDayPreviously.setValue(undefined);
			this.substanceAbuseForm.controls.yearQuitSmoking.setValue(undefined);
			this.substanceAbuseForm.controls.yearsSmokedPreviously.setValue(undefined);
		}
		if (!this.smokedEcigarettesPastYear) {
			this.substanceAbuseForm.controls.concernedAboutEcigaretteUse.setValue(undefined);
		}
		if (!this.usedMarijuanaPastYear) {
			this.substanceAbuseForm.controls.concernedAboutMarijuanaUse.setValue(undefined);
		}
		if (!this.recreationalDrugsPastYear) {
			this.substanceAbuseForm.controls.concernedAboutDrugUse.setValue(undefined);
		}

		const data = this.substanceAbuseForm.getRawValue();
		// Prepopulated value if available and the value has not been updated
		if (this.haService.isValidIndex(data.drinkingFrequencyPastYear)) {
			if (this.returningUser || (!this.returningUser && this.selectionMade('drinkingFrequencyPastYear'))) {
				// data.drinkingFrequencyPastYear = data.drinkingFrequencyPastYear;
			} else if (this.substanceAbuseData.drinkingFrequencyPastYear) {
				data.drinkingFrequencyPastYear = this.substanceAbuseData.drinkingFrequencyPastYear;
			} else {
				data.drinkingFrequencyPastYear = undefined;
			}
		} else {
			data.drinkingFrequencyPastYear = undefined;
		}
		if (this.haService.isValidIndex(data.drinksPerDayPastYear)) {
			if (this.returningUser || (!this.returningUser && this.selectionMade('drinksPerDayPastYear'))) {
				// data.drinksPerDayPastYear = data.drinksPerDayPastYear;
			} else if (this.substanceAbuseData.drinksPerDayPastYear) {
				data.drinksPerDayPastYear = this.substanceAbuseData.drinksPerDayPastYear;
			} else {
				data.drinksPerDayPastYear = undefined;
			}
		} else {
			data.drinksPerDayPastYear = undefined;
		}
		if (this.haService.isValidIndex(data.drinksMoreThanSixPastYear)) {
			if (this.returningUser || (!this.returningUser && this.selectionMade('drinksMoreThanSixPastYear'))) {
				// data.drinksMoreThanSixPastYear = data.drinksMoreThanSixPastYear;
			} else if (this.substanceAbuseData.drinksMoreThanSixPastYear) {
				data.drinksMoreThanSixPastYear = this.substanceAbuseData.drinksMoreThanSixPastYear;
			} else {
				data.drinksMoreThanSixPastYear = undefined;
			}
		} else {
			data.drinksMoreThanSixPastYear = undefined;
		}
		if (this.haService.isValidIndex(data.concernedAboutEcigaretteUse)) {
			if (this.returningUser || (!this.returningUser && this.selectionMade('concernedAboutEcigaretteUse'))) {
				// data.concernedAboutEcigaretteUse = data.concernedAboutEcigaretteUse;
			} else if (this.substanceAbuseData.concernedAboutEcigaretteUse) {
				data.concernedAboutEcigaretteUse = this.substanceAbuseData.concernedAboutEcigaretteUse;
			} else {
				data.concernedAboutEcigaretteUse = undefined;
			}
		} else {
			data.concernedAboutEcigaretteUse = undefined;
		}
		if (this.haService.isValidIndex(data.concernedAboutMarijuanaUse)) {
			if (this.returningUser || (!this.returningUser && this.selectionMade('concernedAboutMarijuanaUse'))) {
				// data.concernedAboutMarijuanaUse = data.concernedAboutMarijuanaUse;
			} else if (this.substanceAbuseData.concernedAboutMarijuanaUse) {
				data.concernedAboutMarijuanaUse = this.substanceAbuseData.concernedAboutMarijuanaUse;
			} else {
				data.concernedAboutMarijuanaUse = undefined;
			}
		} else {
			data.concernedAboutMarijuanaUse = undefined;
		}
		if (this.haService.isValidIndex(data.concernedAboutDrugUse)) {
			if (this.returningUser || (!this.returningUser && this.selectionMade('concernedAboutDrugUse'))) {
				// data.concernedAboutDrugUse = data.concernedAboutDrugUse;
			} else if (this.substanceAbuseData.concernedAboutDrugUse) {
				data.concernedAboutDrugUse = this.substanceAbuseData.concernedAboutDrugUse;
			} else {
				data.concernedAboutDrugUse = undefined;
			}
		} else {
			data.concernedAboutDrugUse = undefined;
		}
		this.subscriptions.push(
			this.lifestyleService
				.saveSubstanceAbuse(this.apptID, {
					...data,
					healthAssessmentID: this.substanceAbuseData.healthAssessmentID,
				})
				.subscribe(
					res => {
						//console.log(res);
					},
					err => {
						console.log(err);
					}
				)
		);
	}

	initializeSubstanceAbuseForm() {
		this.substanceAbuseForm = new FormGroup({
			currentlySmokeCigarettes: new FormControl(''),
			everSmokeCigarettes: new FormControl(''),
			cigarettesPerDay: new FormControl(''),
			yearsOfSmoking: new FormControl(''),
			yearQuitSmoking: new FormControl(''),
			yearsSmokedPreviously: new FormControl(''),
			cigarettesPerDayPreviously: new FormControl(''),
			smokedEcigarettesPastYear: new FormControl(''),
			drinkingFrequencyPastYear: new FormControl(''),
			drinksPerDayPastYear: new FormControl(''),
			drinksMoreThanSixPastYear: new FormControl(''),
			usedMarijuanaPastYear: new FormControl(''),
			concernedAboutMarijuanaUse: new FormControl(''),
			recreationalDrugsPastYear: new FormControl(''),
			concernedAboutDrugUse: new FormControl(''),
			concernedAboutEcigaretteUse: new FormControl(''),
		});
	}
	selectionMade(slider) {
		return this.substanceAbuseForm.get(slider).touched;
	}
}
